export function getIntegrationAlias(integrationName: string) {
  return integrationName.replace(/\//g, '__').replace(/-/g, '_').toLowerCase()
}
